import axios from "axios";

const productCache = {};
const backendUri = process.env.REACT_APP_BACKEND_URI;

export const fetchProductDetails = async (envId) => {
  if (productCache[envId]) {
    return productCache[envId]; 
  }

  try {
    const payloadData = { env_id: envId };
    const response = await axios.post(
      `${backendUri}/kpi/view_product`,
      payloadData
    );

    if (response?.data?.data?.length > 0) {
      const product = response?.data?.data[0];
      const parsedProduct = {
        images: product?.images || [], 
        mrp: product?.mrp || "N/A",
        env_id: product?.env_id || "N?A",
        mfgDate: product?.mfg_date || "N/A",
        expiryDate: product?.expiry_date || "N/A",
        batchNo: product?.batch_no || "N/A",
        ean: product?.ean || "N/A",
        userName: product?.user_name || "N/A",
        deviceName: product?.device_name || "N/A",
        storeId: product?.store_id || "N/A",
        wareHouseId: product?.warehouse_id || "N/A",
        timeStamps: product?.timestamp || "N/A",
      };

      productCache[envId] = parsedProduct; 
      return parsedProduct;
    } else {
      return null;
    }
  } catch (error) {
    throw error;
  }
};

